import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import MerchandiseCard from './MerchandiseCard';
import Footer from './Footer';
import MerchandiseModal from './MerchandiseModal';
import NavbarComponent from './NavbarComponent';

const CompanyPage = () => {
  const { company } = useParams();
  const [merchandiseItems, setMerchandiseItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          'https://api.airtable.com/v0/appWI09FiPgQXRTxb/bakaaro',
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
            },
          }
        );
        const data = await response.json();
        const filteredItems = data.records.filter((item) => item.fields.company_name[0] === company);
        setMerchandiseItems(filteredItems);
      } catch (error) {
        console.error('Error fetching data from Airtable:', error);
      }
    };

    fetchData();
  }, [company]);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="company-page">
      <NavbarComponent />
      <header className="sticky-top bg-light text-center py-4">
        <h1>{company}</h1>
      </header>
      <Container className="mt-4">
        <Row xs={1} sm={2} md={3} lg={4} className="row-cols-md-4 g-2">
          {merchandiseItems.map((item) => (
            <div key={item.id} className="col mb-3">
              <MerchandiseCard
                item={item.fields}
                handleItemClick={handleItemClick}
                handleCloseModal={handleCloseModal}
              />
            </div>
          ))}
        </Row>
      </Container>
      <MerchandiseModal showModal={showModal} handleCloseModal={handleCloseModal} selectedItem={selectedItem} />
      <Footer />
    </div>
  );
};

export default CompanyPage;
